import { Box, Button, Heading, Stack, Text } from '@chakra-ui/react';
import { Outlet, Link as RouterLink } from 'react-router-dom';
import { usePermissions } from 'shared/hooks/usePermissions';
import { NfseProvider } from './NfseContext';

const NfseWrapper = () => {
  const { e } = usePermissions();
  const canRead = e('nfse-read');

  if (!canRead) {
    return (
      <Stack
        h="100vh"
        align="center"
        justify="center"
        gap="1.5rem"
        textAlign="center"
        p="2rem"
      >
        <Heading size="lg" color="gray.600">
          Acesso Restrito
        </Heading>
        <Text color="gray.500" maxW="400px">
          Você não possui permissão para acessar o módulo financeiro. Solicite
          ao seu supervisor para acessar o módulo.
        </Text>
        <Box>
          <Button as={RouterLink} to="/" colorScheme="yooga">
            Voltar para a página inicial
          </Button>
        </Box>
      </Stack>
    );
  }

  return (
    <NfseProvider>
      <Outlet />
    </NfseProvider>
  );
};

export default NfseWrapper;
